
<ul nz-menu  nzMode="inline" [nzTheme]="'light'" [nzInlineCollapsed]="navService.sidenavSmall" class="sider-menu">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: items }" />
      <ng-template #menuTpl let-menus>
        @for (menu of menus; track menu) {
          @if ((!menu.children || menu.children?.length == 0) && menu.level>0) {
            <li
              nz-menu-item
              [nzPaddingLeft]="menu.level * 60"
              [nzDisabled]="menu.disabled"
              [nzSelected]="menu.selected"
              (click)="onItemSelected(menu)"
               
            >
              @if (menu.svgIconName!=null || menu.iconName!=null) {
                <nz-icon [nzType]="menu.svgIconName!=null?'custom:'+menu.svgIconName:menu.iconName" />
              }
              <span>{{('menu.'+menu.id|translateTA)}}</span>
            </li>
          } @else {
            <li
              nz-submenu
              [nzPaddingLeft]="30"
              [nzOpen]="menu.expanded"
              [nzTitle]="'menu.'+menu.id|translateTA"
              [nzIcon]="menu.svgIconName!=null?'custom:'+menu.svgIconName:menu.iconName"
              [nzDisabled]="menu.disabled"
              (click)="onItemSelected(menu)"
            >
              <ul>
                <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }" />
              </ul>
            </li>
          }
        }
      </ng-template>
    </ul>

